import { render } from "./ErrorModalComponent.vue?vue&type=template&id=2c9183ae"
import script from "./ErrorModalComponent.vue?vue&type=script&lang=js"
export * from "./ErrorModalComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ayarmots/MyDev/youtest.ru/youtest-front-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__